<template>
  <div>
    <v-row>
       <!-- <v-fab-transition>
          <v-btn fab top x-small right color="primary"  fixed @click="openInNewTab()">
            <v-icon dark>mdi-open-in-new</v-icon>
          </v-btn>
        </v-fab-transition> -->
      <v-col cols="6" md="3" lg="2">
        <v-autocomplete hide-details item-text="text" v-model="filtersObj.state" item-value="value" :items="hourStates" clearable dense filled :label="$t('message.common.state')"></v-autocomplete>
      </v-col>
      <v-col cols="6" md="3" lg="2">
        <v-autocomplete hide-details item-text="name" multiple item-value="id" :items="getProjects" v-model="filtersObj.projects" dense clearable filled :label="$t('message.layout.projects')">
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.name }}</span>
            <span
              v-if="index === 1"
              class="grey--text caption"
            >(+{{ filtersObj.projects.length - 1 }} {{ $t('message.common.others') }})</span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="6" md="3" lg="2">
        <v-autocomplete hide-details item-text="name" multiple item-value="id" :items="getUsers" v-model="filtersObj.users" dense clearable filled :label="$t('message.layout.user')">
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.name }}</span>
            <span
              v-if="index === 1"
              class="grey--text caption"
            >(+{{ filtersObj.users.length - 1 }} {{ $t('message.common.others') }})</span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="6" md="3" lg="2">
        <v-menu v-model="startMenu" :close-on-content-click="false" :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field hide-details filled clearable v-model="filtersObj.start"
              @click:clear="$nextTick(() => filtersObj.startDatePicker = null)"
              :label="$t('message.common.startDate')" readonly v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="filtersObj.startDatePicker" @input="startMenu = false" first-day-of-week='1'></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="6" md="3" lg="2">
        <v-menu v-model="endMenu" :close-on-content-click="false" :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
          >
          <template v-slot:activator="{ on }">
            <v-text-field hide-details filled clearable v-model="filtersObj.end"
              @click:clear="$nextTick(() => filtersObj.endDatePicker = null)"
              :label="$t('message.common.endDate')" readonly v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="filtersObj.endDatePicker" :min="filtersObj.startDatePicker" @input="endMenu = false" first-day-of-week='1'></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="6" md="3" lg="2">
        <v-btn class="mx-2" @click="getDashBoradData" fab dark small color="primary">
          <v-icon dark>mdi-filter-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="12" class="pt-0 pb-0">
            <v-card tile elevation="5">
              <v-card-title class="pa-3">
                {{ $t('message.dashboard.hoursDetails') }}
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-skeleton-loader class="mx-auto" v-if="chartLoading" type="card"></v-skeleton-loader>
                <highcharts :options="hoursOptions" v-else ref="barChart"></highcharts>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col cols="12" class="pt-0 pb-0">
            <v-card tile elevation="5">
              <v-card-title class="pa-3">
                {{ $t('message.dashboard.employeeDetails') }}
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-skeleton-loader class="mx-auto" v-if="chartLoading" type="card"></v-skeleton-loader>
                <highcharts :options="employeeOptions" v-else ref="barChart"></highcharts>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="12" class="pt-0 pb-0">
            <v-card tile elevation="5">
              <v-card-title class="pa-3">
                {{ $t('message.dashboard.dayDetails') }}
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-skeleton-loader class="mx-auto" v-if="chartLoading" type="card"></v-skeleton-loader>
                <highcharts :options="dayOptions" v-else ref="barChart"></highcharts>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" v-if="getuserDetails.isadmin">
        <v-row>
          <v-col cols="12" class="pt-0 pb-0">
            <v-card tile elevation="5">
              <v-card-title class="pa-3">
                {{ $t('message.dashboard.overviewHours') }}
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-skeleton-loader class="mx-auto" v-if="chartLoading" type="card"></v-skeleton-loader>
                <highcharts :options="stackedChartOptions" v-else ref="barChart"></highcharts>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" v-else>
        <v-row>
          <v-col cols="12" class="pt-0 pb-0">
            <v-card tile elevation="5">
              <v-card-title class="pa-3">
                {{ $t('message.dashboard.overviewHours') }}
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-skeleton-loader class="mx-auto" v-if="chartLoading" type="card"></v-skeleton-loader>
                <highcharts :options="hoursStateOptions" v-else ref="barChart"></highcharts>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CONSTANTS from '../../assets/json/constants.json'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      chartLoading: false,
      startMenu: false,
      endMenu: false,
      filtersObj: {
        start: moment().startOf('month').format('DD.MM.YYYY'),
        end: moment().endOf('month').format('DD.MM.YYYY')
      },
      hoursOptions: {
        chart: {
          type: 'column',
          height: 300
        },
        reflow: false,
        title: {
          text: ''
        },
        plotOptions: { column: { colorByPoint: true } },
        credits: false,
        xAxis: {
          type: 'category'
        },
        yAxis: {
          min: 0,
          allowDecimals: true,
          title: {
            text: 'Hours'
          }
        },
        legend: false,
        series: [{
          dataLabels: {
            enabled: true,
            rotation: -90,
            color: '#FFFFFF',
            align: 'right',
            format: '{point.y}',
            y: 0,
            style: {
              fontSize: '13px',
              fontFamily: 'Verdana, sans-serif'
            }
          }
        }]
      },
      employeeOptions: {},
      dayOptions: {},
      hoursStateOptions: {},
      stackedChartOptions: {
        chart: {
          type: 'column',
          height: 300
        },
        title: {
          text: ''
        },
        credits: false,
        xAxis: {
          categories: []
        },
        yAxis: {
          type: 'logarithmic',
          title: {
            text: 'Overview hours'
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold'
            }
          }
        },
        legend: {
          align: 'right',
          verticalAlign: 'top',
          floating: false,
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true
            },
            minPointLength: 3
          }
        },
        series: []
      }
    }
  },
  computed: {
    ...mapGetters(['getProjects', 'getUsers', 'getuserDetails']),
    hourStates () {
      return [{
        text: this.$t('message.timer.notDelivered'),
        value: CONSTANTS.NOT_DELIVERED
      }, {
        text: this.$t('message.timer.delivered'),
        value: CONSTANTS.DELIVERED
      }, {
        text: this.$t('message.timer.approved'),
        value: CONSTANTS.APPROVED
      }, {
        text: this.$t('message.timer.notApprovedMsg'),
        value: CONSTANTS.NOT_APPROVED
      }]
    }
  },
  watch: {
    'filtersObj.startDatePicker' (val) {
      if (val) {
        this.filtersObj.start = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    'filtersObj.endDatePicker' (val) {
      if (val) {
        this.filtersObj.end = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    filtersObj: {
      deep: true,
      handler (val) {
        this.getDashBoradData()
      }
    }
  },
  created () {
    this.$store.dispatch('getProjects')
    this.$store.dispatch('getUsers')
  },
  mounted () {
    this.employeeOptions = this.$format.cloneVariable(this.hoursOptions)
    this.dayOptions = this.$format.cloneVariable(this.hoursOptions)
    this.hoursStateOptions = this.$format.cloneVariable(this.hoursOptions)
    this.dayOptions.chart.type = 'line'
    this.dayOptions.series[0].dataLabels = {}
    this.getDashBoradData()
  },
  methods: {
    openInNewTab () {
      window.open('/dashboard', '_blank')
    },
    getDashBoradData () {
      this.chartLoading = true
      let transformData = { date: { list: ['start', 'end'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
      let model = this.$format.formatModel(this.filtersObj, transformData)
      this.$api.execute('post', 'dashboard', model)
        .then((response) => {
          let list = [{ data: 'hourschart', model: 'hoursOptions' },
            { data: 'employeechart', model: 'employeeOptions' }]
          if (!this.getuserDetails.isadmin) list.push({ data: 'hoursstatechart', model: 'hoursStateOptions' })
          let getHours = response.data
          for (let x = 0; x < list.length; x++) {
            let labels = getHours[list[x].data].labels
            let data = getHours[list[x].data].values
            let chartData = []
            for (let i = 0; i < data.length; i++) {
              let payload = [labels[i], this.$format.fixedNumbers(data[i])]
              chartData.push(payload)
            }
            let getOption = this[list[x].model].series[0]
            getOption.data = chartData
            getOption.name = 'Hours'
            this.$set(this[list[x].model], 0, getOption)
          }
          let chartData = []
          let getOption = this.dayOptions.series[0]
          Object.keys(getHours.progresschart).forEach(x => {
            let payload = [x, this.$format.fixedNumbers(getHours.progresschart[x])]
            chartData.push(payload)
          })
          getOption.data = chartData
          getOption.name = 'Hours'
          let redLineValue = 0
          if (this.filtersObj.users === undefined || this.filtersObj.users.length === 0) redLineValue = 25
          else if (this.filtersObj.users.length < 5) {
            const usersLength = this.filtersObj.users.length
            redLineValue = 5 * usersLength
          } else {
            redLineValue = 25
          }
          this.$set(this.dayOptions, 0, getOption)
          const colors = this.getChartColors(getHours, 'employeechart')
          this.employeeOptions.plotOptions = { ...this.employeeOptions.plotOptions, ...{ series: { colors: colors } } }
          this.dayOptions.yAxis.plotLines = [{
            color: 'red',
            width: 2,
            value: redLineValue
          }]
          if (!this.getuserDetails.isadmin) {
            const hourStateColors = this.getChartColors(getHours, 'hoursstatechart')
            this.hoursStateOptions.plotOptions = { ...this.hoursStateOptions.plotOptions, ...{ series: { colors: hourStateColors } } }
            this.hoursStateOptions.yAxis.type = 'logarithmic'
            this.hoursStateOptions.yAxis.min = null
          }
          if (this.getuserDetails.isadmin && getHours.hoursstatechartforadmin) {
            const adminStateChart = getHours.hoursstatechartforadmin
            this.stackedChartOptions.xAxis.categories = adminStateChart.labels
            this.stackedChartOptions.series = adminStateChart.values
          }
        })
        .finally(() => {
          this.chartLoading = false
        })
    },
    getChartColors (getHours, chartName) {
      let colors = getHours[chartName].colors
      colors.forEach((color, index) => {
        if (!color) colors[index] = '#7cb5ec' // setting default color
      })
      return colors
    }
  }
}
</script>

<style>

</style>
